<script>
    export let open = false

</script>

<div class="modal {open ? 'is-active' : ''}">
    <div class="modal-background"></div>
    <div class="modal-content">
        <slot></slot>
    </div>
    <button
            on:click={() => open = false}
            class="modal-close is-large"
            aria-label="close">
    </button>
</div>
